import { QueryClient } from '@tanstack/react-query'

const FIVE_MINUTES = 300000

const queryClient: QueryClient = new QueryClient( {
	defaultOptions: {
		queries: {
			staleTime: FIVE_MINUTES,
		},
	},
} )

export default queryClient
